export function zenkakuToHankaku(n: string | number): number {
  if (typeof n === "number") return n
  if (typeof n === "string") {
    const strNum = n.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
    return isNaN(parseInt(strNum)) ? 0 : parseInt(strNum)
  } else {
    return 0
  }
}